module.exports = __webpack_public_path__ + "media/images/new-ui-images/arrow-dark-29baa7e6d673c3b68c1c6fa47d9ff2f7.svg";